import WaveSurfer from 'wavesurfer.js';
export { default as WaveSurfer } from 'wavesurfer.js';

function createWavesurfer(options) {
    return WaveSurfer.create(options);
}

export { createWavesurfer as default };
